module.exports = __webpack_public_path__ + "static/img/18.7f7c344e.jpg";